import { t as tokens } from './tokens-aa5444cd.js';

const BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];
const mapStringToNumber = (breakpoint) => Number(breakpoint.replace('px', ''));
const BREAKPOINT_SIZES = {
    xs: 0,
    sm: mapStringToNumber(tokens.nesBreakpointSm),
    md: mapStringToNumber(tokens.nesBreakpointMd),
    lg: mapStringToNumber(tokens.nesBreakpointLg),
    xl: mapStringToNumber(tokens.nesBreakpointXl),
};

export { BREAKPOINT_SIZES as B, BREAKPOINTS as a };
